import API from "@/api/lib/api";

export const getAllBanquets = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/banquets`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleBanquet = async (id) => {
  try {
    const response = await API.get(`restaurant/banquets/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createBanquet = async (data) => {
  try {
    const response = await API.post(`restaurant/banquets`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateBanquet = async (id, data) => {
  try {
    const response = await API.put(`restaurant/banquets/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteBanquet = async (id) => {
  try {
    const response = await API.delete(`restaurant/banquets/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
